// Manual preview override, e.g. `?ahi-banner=on` forces the banner to render even
// when BANNER_ENABLED is false, `?ahi-banner=off` force-hides it. For humans
// testing before/after a config change goes live - changes nothing for real
// visitors browsing without the query param.
export type Override = "on" | "off" | null;

export function readOverride(search: string): Override {
  const value = new URLSearchParams(search).get("ahi-banner");
  if (value == null) return null;
  const v = value.toLowerCase();
  if (v === "on" || v === "true" || v === "1" || v === "yes") return "on";
  if (v === "off" || v === "false" || v === "0" || v === "no") return "off";
  return null;
}
